export const Matches = {
  QUESTION_ID: ":questionId",
  PRODUCT_NAME: ":product",
  VISIT_ID: ":visitId",
  THREAD_ID: ":threadId",
  SUBSCRIPTION_ID: ":subscriptionId",
  LANGUAGE: ":language",
  PRODUCT_ID: ":productId",
  VARIANT: ":variant?",
} as const;

export type MatchParam<T extends keyof typeof Matches> =
  (typeof Matches)[T] extends `:${infer U}` ? U : never;
